module.exports = __webpack_public_path__ + "static/fonts/element-icons.6f0a763.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = YiW1
// module chunks = 14